import { render, staticRenderFns } from "./shuiwuzouhua.vue?vue&type=template&id=16bf051e&scoped=true&"
import script from "./shuiwuzouhua.vue?vue&type=script&lang=js&"
export * from "./shuiwuzouhua.vue?vue&type=script&lang=js&"
import style0 from "./shuiwuzouhua.vue?vue&type=style&index=0&id=16bf051e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf051e",
  null
  
)

export default component.exports